import { Loading } from "@lyfegen-platform/react-common";
import { Box } from "@material-ui/core";

interface LoadingBoxProps {
	style?: React.CSSProperties;
	fullHeight?: boolean;
	fixedHeight?: number;
}

const LoadingBox: React.FC<LoadingBoxProps> = ({ style, fullHeight, fixedHeight }) => (
	<Box
		width="100%"
		height={fullHeight ? "calc(100vh - 220px)" : fixedHeight ? fixedHeight : "100%"}
		display="flex"
		justifyContent="center"
		alignItems="center"
		style={style}
	>
		<Loading />
	</Box>
);
export default LoadingBox;
